import { render, staticRenderFns } from "./infor-card.vue?vue&type=template&id=6311e6cc"
import script from "./infor-card.vue?vue&type=script&lang=js"
export * from "./infor-card.vue?vue&type=script&lang=js"
import style0 from "./infor-card.vue?vue&type=style&index=0&id=6311e6cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports